(function () {
  const FEE_VARIANT_ID = 56318900568443;
  const DESTINATION_KEY = "delivery_destination";

  const CATEGORY_TO_HS = {
    "Accessories": "3926.40.0000",
    "Adhesives": "3506.10.0000",
    "Blending Brushes": "9603.30.1000",
    "Brushes": "9603.30.1000",
    "Cardstock": "4802.57.0000",
    "Craft Tools": "8205.59.8000",
    "Die Cutting": "8207.30.6032",
    "Embellishments": "3926.90.4000",
    "Embossing Folders": "3926.10.0000",
    "Embossing Pastes": "3407.00.2000",
    "Embossing Powders": "3304.91.0000",
    "Envelopes": "4817.10.0000",
    "Fabric": "5602.00.0000",
    "Hot Foil Plates": "8442.50.0000",
    "Hot Foils": "3213.10.0000",
    "Ink Pads": "9612.20.0000",
    "Ink Sprays": "3215.90.7000",
    "Kits": "9611.00.0000",
    "Markers": "9608.20.0000",
    "Paints": "3213.10.0000",
    "Paper Packs": "4823.90.8500",
    "Patterns": "4909.00.0000",
    "Press Plates": "8442.50.0000",
    "Re-inkers": "3215.90.1000",
    "Stamps": "9611.00.0000",
    "Stencil-Mates": "4802.57.0000",
    "Stencils": "9017.20.8080",
    "Storage": "3923.10.9000",
    "Toner Foils": "3212.10.0000",
    "Toner Sheets": "4802.57.0000",
    "Washi Tapes": "3919.10.8000",
    "Wax Melting": "3406.00.0000",
    "Wax Stamping": "3406.00.0000",
    "Wool/Yarn": "5509.00.0000"
  };

  function getDestination() {
    return localStorage.getItem(DESTINATION_KEY);
  }

  function saveDestination(destination) {
    localStorage.setItem(DESTINATION_KEY, destination);
  }

  function setMessage(text) {
    const message = document.getElementById("eu-fee-message");
    if (message) message.textContent = text || "";
  }

  function setCheckout(enabled) {
    const button = document.getElementById("checkout-button");
    if (!button) return;

    button.disabled = !enabled;
    button.style.opacity = enabled ? "1" : "0.5";
  }

  async function getCart() {
    const response = await fetch("/cart.js");
    return response.json();
  }

  async function removeDutyFee(cart) {
    const dutyItem = cart.items.find(item => item.variant_id === FEE_VARIANT_ID);

    if (!dutyItem) return false;

    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: String(FEE_VARIANT_ID),
        quantity: 0
      })
    });

    return true;
  }

  async function addDutyFee(quantity) {
    if (quantity <= 0) return false;

    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            id: FEE_VARIANT_ID,
            quantity: quantity
          }
        ]
      })
    });

    return true;
  }

  function countUniqueHsCodes(cart) {
    const hsCodes = [];

    cart.items.forEach(item => {
      if (item.variant_id === FEE_VARIANT_ID) return;

      const productType = item.product_type ? item.product_type.trim() : "";

      if (CATEGORY_TO_HS[productType]) {
        hsCodes.push(CATEGORY_TO_HS[productType]);
      }
    });

    return [...new Set(hsCodes)].length;
  }

  async function refreshDuty(options) {
    const shouldReload = options && options.reload;
    const destination = getDestination();

    try {
      setCheckout(false);
      setMessage("Updating basket...");

      const cart = await getCart();
      const removedDuty = await removeDutyFee(cart);

      if (destination === "EU") {
        const uniqueCount = countUniqueHsCodes(cart);

        if (uniqueCount > 0) {
          await addDutyFee(uniqueCount);
          setMessage("EU import duty has been added.");
          if (shouldReload) window.location.reload();
          return;
        }
      }

      setMessage(destination === "EU" ? "No EU import duty needed." : "No EU import duty added.");

      if (removedDuty && shouldReload) {
        window.location.reload();
        return;
      }

      setCheckout(true);
    } catch (error) {
      console.error("EU duty error:", error);
      setMessage("Sorry, there was a problem updating the basket. Please refresh and try again.");
      setCheckout(false);
    }
  }

  function restoreSelectedDestination() {
    const saved = getDestination();

    if (!saved) {
      setCheckout(false);
      return;
    }

    const radio = document.querySelector(
      'input[name="delivery_destination"][value="' + saved + '"]'
    );

    if (radio) radio.checked = true;

    setCheckout(true);
  }

  document.addEventListener("change", function (event) {
    if (!event.target.matches('input[name="delivery_destination"]')) return;

    saveDestination(event.target.value);
    refreshDuty({ reload: true });
  });

document.addEventListener("DOMContentLoaded", function () {
  restoreSelectedDestination();

  const saved = getDestination();

  if (saved === "EU") {
    refreshDuty({ reload: false });
  }
}); 
})();